import React, { useEffect, useState } from 'react'
import notes from '../assets/images/notes.png'
import doubleImage from '../assets/images/double-tick.png'
import pluss from '../assets/images/plus.png'
import {
  useAddTodoMutation,
} from '../features/api/todoSlice'
const Header = ({ filter, setFilter,toggle,setToggle }) => {
  const [addTodo, { isLoading, isSuccess, isError }] = useAddTodoMutation()
  const [writeTodo, setWriteTodo] = useState('')
  useEffect(() => {
    if (isSuccess || isError) {
      setWriteTodo('')
    }
  }, [isSuccess, isError])
  const handleAddTodo = (e) => {
    if (writeTodo === '') return
    addTodo({
      todo: {
        text: writeTodo,
        completed: false,
        color: '',
        id: Date.now(),
      },
    })
    e.preventDefault()
  }
  const handleAllTaskCompleted = async () => {
    setToggle({ completed: false })
    setFilter('all-completed')
  }
  const handleAllTaskClear = () => {
    setToggle({ completed: true })
    setFilter('clear-complete')
  }
  return (
    <>
      <div>
        <form className="flex items-center bg-gray-100 px-4 py-4 rounded-md">
          <img src={notes} className="w-6 h-6" alt="Add todo" />
          <input
            onChange={(e) => setWriteTodo(e.target.value)}
            type="text"
            value={writeTodo}
            placeholder="Type your todo"
            className="w-full text-lg px-4 py-1 border-none outline-none bg-gray-100 text-gray-500"
          />
          <button
            disabled={isLoading}
            className={`appearance-none w-8 h-8 bg-[url(${pluss})] bg-no-repeat bg-contain cursor-pointer`}
            onClick={(e) => handleAddTodo(e)}
          ></button>
        </form>

        <ul className="flex justify-between my-4 text-xs text-gray-500">
          <li className="flex space-x-1 cursor-pointer">
            <img className="w-4 h-4" src={doubleImage} alt="Complete" />
            <span onClick={() => handleAllTaskCompleted()}>Complete All Tasks</span>
          </li>
          <li className="cursor-pointer" onClick={() => handleAllTaskClear()}>
            Clear completed
          </li>
        </ul>
      </div>
    </>
  )
}

export default Header
